module.exports = __webpack_public_path__ + "img/MTABAPPTBI.febb3038.svg";